module.exports = __webpack_public_path__ + "assets/img/ic-recovery.f6d130c1.svg";